var _style, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#1C75BC;stroke-width:0.75;stroke-miterlimit:2.6131;}\n\t.st1{fill:#1B75BC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.2,9.5h47.6c2.1,0,3.8,1.7,3.8,3.8v42.9c0,2.1-1.7,3.8-3.8,3.8H8.2c-2.1,0-3.8-1.7-3.8-3.8V13.3 C4.5,11.2,6.2,9.5,8.2,9.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "4.5,24.2 59.5,24.2 43.9,16.1 20.1,16.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.2,17.6c0-4.1,0-7.7,0-11.8c1.2-2.4,3.9-2.1,4.8,0v10.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.1,17.6c0-4.1,0-7.7,0-11.8c-1.2-2.4-3.9-2.1-4.8,0v10.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.5,
    y1: 24.2,
    x2: 55.8,
    y2: 59.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "59.5,24.2 4.5,54.5 55.8,59.9  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.9,
    y1: 9.5,
    x2: 4.5,
    y2: 22.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 50,
    y1: 9.5,
    x2: 59.5,
    y2: 14.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "4.5,24.2 32.9,18.8 59.5,24.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "43.9,16.1 32.9,18.8 20.1,16.1  "
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 55.1,
    cy: 59.5,
    r: 1.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 59.1,
    cy: 24,
    r: 1.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 43.9,
    cy: 16.3,
    r: 1.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 20.1,
    cy: 16.1,
    r: 1.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 5,
    cy: 54.6,
    r: 1.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 4.5,
    cy: 24.1,
    r: 1.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/Events.8b7628967237ad9f4477bf83e86c80e5.svg";
export { ForwardRef as ReactComponent };